import axios from '@/libs/api.request'

const tradTrends = {
    // 交易趋势（按天）
    getDaysTrends: (data) => {
        return axios.post({
            url: '/ShopSalesDetail/DaysTrends',
            data: data
        })
    },
    // 交易趋势（按周）
    getWeeksTrends: (data) => {
        return axios.post({
            url: '/ShopSalesDetail/WeeksTrends',
            data: data
        })
    },
    // 交易趋势（按月）
    getMonthsTrends: (data) => {
        return axios.post({
            url: '/ShopSalesDetail/MonthsTrends',
            data: data
        })
    }
}
export default tradTrends


// WEBPACK FOOTER //
// ./src/api/api-tradTrends.js